<template lang="pug">
  ItemList(
    v-model="searchQuery"
    search-placeholder="Поиск по персоналу"
    :is-show-search-tip="persons.length === 0"
  )
    ItemListOption(
      v-for="person in persons"
      :key="person.id"
      input-name="persons"
      :id="person.id"
      :desc="person.desc"
      :title="person.name"
      :rating="person.rating"
      :price="priceToString(person.price)"
      :is-show-avatar="true"
      :avatar-url="person.img"
      :checked="person.id === currentPersonId"
      @change="changeHandler(person.id)"
    )

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import priceToString from "@/mixins/price-to-string";
import ItemList from "@/components/ItemList/ItemList";
import ItemListOption from "@/components/ItemList/ItemListOption.vue";

export default {
  name: 'PersonList',
  mixins: [priceToString],
  components: {
    ItemList,
    ItemListOption
  },
  computed: {
    ...mapGetters('person', ['getPersonsByNameIncludes', 'currentPersonId']),
    persons() {
      return this.getPersonsByNameIncludes(this.searchQuery);
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  methods: {
    ...mapActions('person', ['clearPersonDependencies', 'setCurrentPerson']),
    changeHandler(id) {
      this.setCurrentPerson(id);
      this.clearPersonDependencies();
      setTimeout(() => this.$router.go(-1), 150);
    }
  },
};
</script>
